"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_KEY = 'ths_widget.user';
exports.setUser = function (userId) {
  localStorage.setItem(USER_KEY, userId);
  return localStorage.getItem(USER_KEY) || '';
};
exports.getUser = function () {
  return localStorage.getItem(USER_KEY) || '';
};